<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <public-place-form />
  </v-container>
</template>

<script>
import PublicPlaceForm from './_Form'

export default {
  name: 'OrderMasterPublicPlaceEdit',
  components: {
    PublicPlaceForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: '公共積替一覧', disabled: false, to: '/driver/masters/public_places', exact: true },
        { text: '公共積替編集', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>

